import React from "react";
import styles from "./Navbar.module.css";
import authContext from "../../store/auth-context";
import userDataContext from "../../store/userData-context";
import { Link } from "react-router-dom";
import { gsap, Power4 } from "gsap";
const logo = require("../../images/logomusic.png");
const expand = require("../../images/expand-arrow.png");

const Navbar = () => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const authCtx = React.useContext(authContext);
  const userDataCtx = React.useContext(userDataContext);

  function toggleExpanded() {
    setIsExpanded((prev) => !prev);
  }
  function logOut() {
    authCtx.logOut();
    toggleExpanded();
  }

  const collapsedStyling = {
    transform: isExpanded ? "rotate(180deg)" : "rotate(0)",
  };

  const playlistHtml = userDataCtx.playlists.map((playlist) => (
    <Link to="/playlist" key={playlist.name}>
      <li
        onClick={() => {
          userDataCtx.setView(playlist.name, playlist.songs);
        }}
      >
        {playlist.name}
      </li>
    </Link>
  ));

  React.useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      let mm = gsap.matchMedia();
      mm.add("(min-width: 880px)", () => {
        gsap.from("nav", { x: -1000, duration: 2, ease: Power4.easeOut });
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <nav className={`${styles.navbar}`}>
      <Link to="/" className={styles["logo-container"]}>
        <img src={logo} alt="Music App" width="60px" height="50px" />
        <p>Music App</p>
      </Link>
      <img
        onClick={toggleExpanded}
        className={styles.expand}
        src={expand}
        alt="Expand navbar content"
        data-testid="toggler"
        style={collapsedStyling}
      />
      <ul
        className={`${styles["navbar-list"]} ${
          !isExpanded ? styles.collapsed : ""
        }`}
      >
        <li onClick={toggleExpanded}>
          <Link to="/" aria-label="Go to homepage">
            <i className="fa-solid fa-house"></i>
            Home
          </Link>
        </li>
        <li onClick={toggleExpanded}>
          <Link to="/search" aria-label="Go to search page">
            <i className="fa-solid fa-magnifying-glass"></i>
            Search
          </Link>
        </li>
        <li onClick={toggleExpanded}>
          <Link to="/public" aria-label="Go to public playlists">
            <i className="fa-solid fa-radio"></i>
            Public Playlists
          </Link>
        </li>
        <li onClick={toggleExpanded}>
          {authCtx.isLoggedIn ? (
            <button
              className={styles.logOut}
              onClick={logOut}
              aria-label="Log out of account"
            >
              Log Out
            </button>
          ) : (
            <Link
              to="/login"
              data-testid="login"
              aria-label="Log in to your account"
            >
              <i className="fa-solid fa-right-to-bracket"></i>
              Log In
            </Link>
          )}
        </li>
      </ul>
      {userDataCtx.playlists.length > 0 && (
        <div className={styles.playlists}>
          <h3 className={styles["playlist-title"]}>Your Playlists</h3>
          <ul className={styles["playlist-list"]}>{playlistHtml}</ul>
        </div>
      )}
      <div className={styles["nav-copyright"]}>
        <p>Created by Paul Melton</p>
        <a href="https://paulcmelton.com" target="_blank" rel="noreferrer">
          PaulCMelton.com
        </a>
      </div>
    </nav>
  );
};
export default Navbar;
